import React, { useState, useEffect } from 'react';
import axios from 'axios';
import config from '../../config/apiConfig';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Modal } from 'react-responsive-modal';
import 'react-responsive-modal/styles.css';
import Procesando from '../Generales/Procesando';

function ConfiguracionCajas() {
    const [cajas, setCajas] = useState([]);
    const [cargando, setCargando] = useState(false);
    const [nuevoNombre, setNuevoNombre] = useState('');
    const [nuevoDesc, setNuevoDesc] = useState('');

    useEffect(() => {
        axios.defaults.headers.common['token'] = localStorage.getItem('token');
        getDatos();
    }, []);

    async function getDatos() {
        setCargando(true);
        try {
            const resp = await axios.get(config.api_url + '/configuracion/cajas/');
            if (resp.data.completado) setCajas(resp.data.cajas);
        } catch {
            toast.error('Error al cargar las cajas.');
        } finally {
            setCargando(false);
        }
    }

    function modificarCampo(indice, campo, valor) {
        const arr = [...cajas];
        arr[indice][campo] = valor;
        setCajas(arr);
    }

    async function guardarCaja(caja) {
        setCargando(true);
        try {
            const resp = await axios.put(config.api_url + '/configuracion/cajas/' + caja.id + '/', {
                nombre: caja.nombre,
                descripcion: caja.descripcion,
            });
            if (resp.data.completado) toast.success(resp.data.mensaje);
            else toast.error(resp.data.mensaje);
        } catch {
            toast.error('Error al guardar la caja.');
        } finally {
            setCargando(false);
        }
    }

    async function eliminarCaja(cajaId) {
        if (!window.confirm('¿Eliminar esta caja?')) return;
        setCargando(true);
        try {
            const resp = await axios.delete(config.api_url + '/configuracion/cajas/' + cajaId + '/');
            if (resp.data.completado) { toast.success(resp.data.mensaje); getDatos(); }
            else toast.error(resp.data.mensaje);
        } catch {
            toast.error('Error al eliminar la caja.');
        } finally {
            setCargando(false);
        }
    }

    async function crearCaja() {
        if (!nuevoNombre.trim()) { toast.error('El nombre es obligatorio.'); return; }
        setCargando(true);
        try {
            const resp = await axios.post(config.api_url + '/configuracion/cajas/', {
                nombre: nuevoNombre.trim(),
                descripcion: nuevoDesc.trim(),
            });
            if (resp.data.completado) {
                toast.success(resp.data.mensaje);
                setNuevoNombre('');
                setNuevoDesc('');
                getDatos();
            } else {
                toast.error(resp.data.mensaje);
            }
        } catch {
            toast.error('Error al crear la caja.');
        } finally {
            setCargando(false);
        }
    }

    return (
        <div className="contenedorMantenedor">
            <ToastContainer />
            <Modal open={cargando} showCloseIcon={false} center>
                <Procesando />
            </Modal>
            <div className="card">
                <div className="card-header">
                    <div className="row">
                        <div className="col-md-4">
                            <a href="/configuracion/home/"><i className="bi bi-arrow-left-short"></i>Regresar</a>
                        </div>
                        <div className="col-md-4 titulo-formulario">
                            <label>Configuración de Cajas / Terminales</label>
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    <p className="text-muted small">
                        Las cajas o terminales identifican desde qué punto de venta se generó cada pedido.
                        Al iniciar sesión, el usuario selecciona la caja activa y todos sus pedidos quedan
                        asociados a ella en los reportes y el cierre de caja.
                    </p>
                    <div className="container">
                        <table className="table table-striped">
                            <thead className="thead-dark">
                                <tr>
                                    <th>Nombre</th>
                                    <th>Descripción</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {cajas.map((caja, idx) => (
                                    <tr key={caja.id}>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={caja.nombre}
                                                onChange={(e) => modificarCampo(idx, 'nombre', e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={caja.descripcion || ''}
                                                placeholder="Descripción opcional"
                                                onChange={(e) => modificarCampo(idx, 'descripcion', e.target.value)}
                                            />
                                        </td>
                                        <td style={{ whiteSpace: 'nowrap' }}>
                                            <button className="btn btn-sm btn-primary mr-1" onClick={() => guardarCaja(caja)}>Guardar</button>
                                            <button className="btn btn-sm btn-danger" onClick={() => eliminarCaja(caja.id)}>Eliminar</button>
                                        </td>
                                    </tr>
                                ))}
                                <tr>
                                    <td>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Ej: Caja Bar"
                                            value={nuevoNombre}
                                            onChange={(e) => setNuevoNombre(e.target.value)}
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Descripción opcional"
                                            value={nuevoDesc}
                                            onChange={(e) => setNuevoDesc(e.target.value)}
                                        />
                                    </td>
                                    <td>
                                        <button className="btn btn-sm btn-success" onClick={crearCaja}>Agregar</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ConfiguracionCajas;
